/**
 * In-tab idle logout timings by role (1.1.8).
 *
 * Parent and tutor: 25 minutes of inactivity, then a 5-minute countdown (30 minutes total).
 * Board, admin, super-admin, and custom roles: 10 minutes + 5-minute countdown (15 minutes total).
 * Unknown / missing role uses the shorter leadership window (fail closed).
 *
 * Idle only applies while the tab is open. Closing the browser is controlled by
 * Keep me signed in (refresh cookie), not these timers.
 */

export const IDLE_COUNTDOWN_SECONDS = 5 * 60;

const PARENT_TUTOR_WARNING_MS = 25 * 60 * 1000;
const LEADERSHIP_WARNING_MS = 10 * 60 * 1000;

export function isFamilyOrTutorIdleRole(role: string | undefined | null): boolean {
  return role === 'parent' || role === 'tutor';
}

/** Milliseconds of inactivity before the "Are you still there?" modal. */
export function inactivityWarningMs(role: string | undefined | null): number {
  return isFamilyOrTutorIdleRole(role) ? PARENT_TUTOR_WARNING_MS : LEADERSHIP_WARNING_MS;
}

/** Total idle time until forced logout (warning + countdown). */
export function idleLogoutTotalMs(role: string | undefined | null): number {
  return inactivityWarningMs(role) + IDLE_COUNTDOWN_SECONDS * 1000;
}
